import { render, staticRenderFns } from "./BattlesHeaderGame.vue?vue&type=template&id=9460495a&scoped=true"
import script from "./BattlesHeaderGame.vue?vue&type=script&lang=js"
export * from "./BattlesHeaderGame.vue?vue&type=script&lang=js"
import style0 from "./BattlesHeaderGame.vue?vue&type=style&index=0&id=9460495a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9460495a",
  null
  
)

export default component.exports